import React from 'react';
import cls from 'classnames';

import { utils } from '@/lib';
import Styled from './styled';
import { ItemProps } from '../types';

const Slider = (
  props: ItemProps & {
    min?: number;
    step?: number;
    max?: number;
  },
) => {
  const {
    label,
    disabled = false,
    className,
    name,
    min = 0,
    max = 100,
    step = 1,
    value = props.max || 0,
    onChange,
  } = props;

  return (
    <Styled.Slider
      className={cls('form-item form-item-slider', className, { disabled })}
    >
      {label && <label className="form-item-label">{label}</label>}
      <div className={cls('form-item-input', {})}>
        <div className="progress-bar">
          <p
            className="progress-fill"
            style={{ width: utils.toPercent((value || 0) - min, max - min) }}
          >
            <span className="progress-val">{value || '0'}</span>
          </p>
        </div>
        <input
          type="range"
          disabled={disabled}
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(name, e.target.value)}
        />
      </div>
    </Styled.Slider>
  );
};

export default Slider;
